import React from "react";
import MainReferral from "../../Components/Referral";

const Referral = () => <MainReferral />;

export default Referral;
